import { INav } from "@types"
import { Box } from "theme-ui"
import { Link } from "react-router-dom"

export interface InnerNavProps {
 nav: INav[]
}
export const InnerSubNav = ({ nav }: InnerNavProps) => {
 return (
  <>
   <Box
    bg="highlight"
    className="border z-30 relative bottom-5 lg:top-[-15px] top-10 left-24 lg:left-[250px] px-4 py-3 lg:w-64 w-64"
   >
    {nav.map((nav: INav, index: number) => (
     <div key={index}>
      <Link to={"/" + nav.slug} key={index} className="hover:text-yellow my-3 cursor-pointer">
       {nav.name}
      </Link>
     </div>
    ))}
   </Box>
  </>
 )
}
